export default __webpack_public_path__ + "static/media/img-4.ca952023.jpg";